import { DefaultLayout, PublicLayout, EmptyState } from 'layouts';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { userSelector } from 'redux/userSlice';



function SplashPage() {
    return <EmptyState message={<FormattedMessage id="SPLASH.UNAVAILABLE" />} />;
}

export default function SplashPageComponent(props) {
    const { isSuccess: loggedIn } = useSelector(userSelector);

    if (loggedIn) return <DefaultLayout page={<SplashPage />} />;
    else return <PublicLayout page={<SplashPage />} />;
};